'use strict';

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var pReduce = require('p-reduce');

var is = require('@sindresorhus/is');

module.exports = function (iterable) {
  var ret = [];

  var _iterator = _createForOfIteratorHelper(iterable),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var task = _step.value;
      var type = is(task);

      if (type !== 'Function') {
        return Promise.reject(new TypeError("Expected task to be a `Function`, received `".concat(type, "`")));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return pReduce(iterable, function (_, fn) {
    return Promise.resolve().then(fn).then(function (val) {
      ret.push(val);
    });
  }).then(function () {
    return ret;
  });
};